import api from "../utils/axiosConfig";

export type ReferralCodeResponse = {
  code: string;
  valid: boolean;
};

export const checkReferralCode = async (
  code: string
): Promise<ReferralCodeResponse> => {
  const response = await api.get<ReferralCodeResponse>(
    `/auth/referral-codes/${encodeURIComponent(code.trim())}`
  );
  return response.data;
};
